var InputAdornmentEnum;
(function (InputAdornmentEnum) {
  InputAdornmentEnum["Both"] = "both";
  InputAdornmentEnum["End"] = "end";
  InputAdornmentEnum["None"] = "none";
  InputAdornmentEnum["Start"] = "start";
})(InputAdornmentEnum || (InputAdornmentEnum = {}));

export { InputAdornmentEnum };
//# sourceMappingURL=types.js.map
